import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	AppendixSevenDTO,
	AppendixSevenRequest,
	AppendixSevenSaveDTO,
} from '../DTO/forms-management/appendix7';

export const appendix7 = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAppendix7List: builder.query<
			SuccessResponse<AppendixSevenDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/form/appendix-seven/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['Appendix7List'],
		}),
		deleteAppendix7: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-seven/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['Appendix7List'],
		}),
		Appendix7HasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/appendix-seven/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getAppendix7Draft: builder.query<
			SuccessResponse<AppendixSevenSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-seven/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueAppendix7Draft: builder.mutation<
			SuccessResponse<AppendixSevenSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/appendix-seven/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editAppendix7: builder.mutation<SuccessResponse<any>, AppendixSevenRequest>(
			{
				query: (body) => ({
					url: `/web/form/appendix-seven/${body.id}`,
					method: 'PUT',
					body,
				}),
			}
		),
		createAppendix7: builder.mutation<
			SuccessResponse<any>,
			AppendixSevenRequest
		>({
			query: (body) => ({
				url: `/web/form/appendix-seven`,
				method: 'POST',
				body,
			}),
		}),
		getAppendix7Detail: builder.query<
			SuccessResponse<AppendixSevenDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/form/appendix-seven/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetAppendix7ListQuery,
	useDeleteAppendix7Mutation,
	useAppendix7HasDraftQuery,
	useGetAppendix7DraftQuery,
	useContinueAppendix7DraftMutation,
	useEditAppendix7Mutation,
	useCreateAppendix7Mutation,
	useGetAppendix7DetailQuery,
} = appendix7;
